export default "__VITE_ASSET__C8m1493v__"